export var SORT_ASC = 'ASCENDING';
export var SORT_DESC = 'DESCENDING';
// used in accurity ui workspace
export var COLUMN_DEFAULT_WIDTH_POINTS = 1000;
export var COLUMN_MINIMUM_PIXEL_WIDTH = 45;
// used in accurity ui workspace
export var TIME_FILTER_MASK_FORMAT = '__:__:__';
export var DEFAULT_COMPARISON_OPTIONS = ['<', '<=', '=', '>', '>=', '-='];
export var DEFAULT_COMPARISON = '=';
//# sourceMappingURL=constants.js.map